
import { Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

export type SetpointListItemCardProps = {
    title: string,
    children?: ReactNode;    
};

export function SetpointListItemCard({
    title,
    children
}: SetpointListItemCardProps) {

    const theme = useTheme();

    return (
        <Box sx={{
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 6,
            marginRight: 1,
            padding: 1
        }}>

            <Typography variant="body2"
                sx={{
                    color: theme.palette.grey[600]
                }}>
                {title}
            </Typography>

            {children}

        </Box>    
    );
}

